import React from 'react';
import { Stack, Typography } from '@mui/material';
// import CustomRichTextEditor from '../../../../Marketing/CustomRichTextEditor';

export default function DynamicHtmlEditor({ formik, field, name = 'html' }: { formik: any; field: any; name: string }) {
    return (
        <Stack m={0}>
            <Typography fontWeight={700} variant="body1">
                {field?.name}
            </Typography>

            <div dangerouslySetInnerHTML={{ __html: formik?.values?.[name] || '' }} />

            {/* <CustomRichTextEditor
                value={formik?.values?.[name] || ''}
                onChange={(html) => formik.setFieldValue(name, html)}
                disabled={formik?.values?.disabled}
                readOnly={formik?.values?.disabled}
                className="mt-2 md:ml-2"
            /> */}

            {/* {formik?.touched?.[name] && formik?.errors?.[name] && (
                <Typography style={{ color: 'red' }}>{formik?.errors?.[name]}</Typography>
            )} */}
        </Stack>
    );
}
